/* eslint-disable no-underscore-dangle */
/* eslint-disable @typescript-eslint/naming-convention */
import { Dropdown } from '@telus/d2c-core';
import {
  DropdownCommon,
  LanguagePage,
  PageTitles,
  WalklistType,
} from '@telus/d2c-core/lib/common';

// This array is used to create the menu and Tab-menu
export const menuPages = [
  {
    title: `${LanguagePage.vendorGroupSales}.${PageTitles.vendor}`,
    name: PageTitles.vendor,
    url: `/app/${PageTitles.vendor}`,
    icon: 'people',
  },
  {
    title: `${LanguagePage.territoryWalklist}.${PageTitles.territoryWalklist}`,
    name: PageTitles.territoryWalklist,
    url: `/app/${PageTitles.territoryWalklist}`,
    icon: 'map',
  },
  {
    title: `${LanguagePage.appConfig}.${PageTitles.appConfig}`,
    name: PageTitles.appConfig,
    url: `/app/${PageTitles.appConfig}`,
    icon: 'construct',
  },
  {
    title: `${LanguagePage.intel}.${PageTitles.intel}`,
    name: PageTitles.intel,
    url: `/app/${PageTitles.intel}`,
    icon: 'construct',
  },
  {
    title: `${LanguagePage.address360}.${PageTitles.address360}`,
    name: PageTitles.address360,
    url: `/app/${PageTitles.address360}`,
    icon: 'people',
  },
  {
    title: `${LanguagePage.sales}.${PageTitles.sales}`,
    name: PageTitles.sales,
    url: `/app/${PageTitles.sales}`,
    icon: 'people',
  },
];

export const adminPages = [
  {
    title: `${LanguagePage.roleUser}.${PageTitles.roleUser}`,
    name: PageTitles.roleUser,
    url: `/app/${PageTitles.roleUser}`,
    icon: 'people',
  },
  {
    title: `${LanguagePage.globalSearch}.${PageTitles.globalSearch}`,
    name: PageTitles.globalSearch,
    url: `/app/${PageTitles.globalSearch}`,
    icon: 'people',
  },
];

export const configPages = [
  {
    title: `${LanguagePage.menu}.${PageTitles.menu}`,
    name: PageTitles.menu,
    url: `/app/${PageTitles.menu}`,
    icon: 'people',
  },
];

// TODO: This is data used to populate the dropdown component for walklist type
//
export const walklistTypeDropdown: Dropdown[] = [
  { value: '', text: DropdownCommon.selectOption, checked: true },
  { value: 'S', text: WalklistType.sales, checked: true },
  { value: 'D', text: WalklistType.dropPermission, checked: true },
];

export const walklistTypeDropdownNoDefaultValue: Dropdown[] = [
  { value: 'S', text: WalklistType.sales, checked: true },
  { value: 'D', text: WalklistType.dropPermission, checked: true },
];

export interface IFilter {
  enable: boolean;
  views: string[];
  layer: string;
  key: string;
  type: string;
  operations: string[];
  always_null?: boolean;
  note?: string;

  values?: IFilterValue[];
}

export interface IFilterValue {
  key: string;
  label: string;
  value: string | null;

  checked: boolean;
  default: boolean;
  visible?: boolean;
  join?: string;
  subfilter?: string;
  coid?: string;
}

export class Filter {
  private state: IFilter;
  private checked = false;
  private value: string;
  private operator: string;
  private _display = false;
  private _selectAll = false;
  private _selectAllChecked = false;

  constructor(filter: IFilter) {
    this.state = filter;
  }

  get enable(): boolean {
    return this.state.enable;
  }

  get views(): string[] {
    return this.state.views;
  }

  get layer(): string {
    return this.state.layer;
  }

  get key(): string {
    return this.state.key;
  }

  get type(): string {
    return this.state.type;
  }

  get operations(): string[] {
    return this.state.operations;
  }

  get values(): IFilterValue[] {
    return this.state.values;
  }

  get alwaysNull(): boolean {
    return this.state.always_null;
  }

  get selectAll(): boolean {
    return this._selectAll;
  }

  get selectAllChecked(): boolean {
    return this._selectAllChecked;
  }

  set selectAllChecked(value) {
    this._selectAllChecked = value;
  }

  public get display() {
    return this._display;
  }

  public set display(display: boolean) {
    this._display = display;
  }
}
